import ReactDom from "react-dom";
import * as R from "ramda";

import GlobalModal from "./GlobalModal.jsx";

export default function renderGlobalModals() {
  const modalMounts = Array.from(
    document.querySelectorAll(".js-global-modal-mount"),
  );

  if (R.isEmpty(modalMounts)) {
    return;
  }

  /* render modals */

  // map of { name: ref } of all the global modals
  // ref.current is { openModal, closeModal }, see GlobalModal.jsx
  const modalRefs = R.compose(
    R.fromPairs,
    R.reject(R.isNil), // remove invalid modal mounts
    R.map((mount) => {
      const name = mount.dataset.name;
      const content = mount.children || [];
      let modalRef = {};

      if (!name || name.length === 0) {
        console.error("This global modal needs a valid data-name!", mount);
        return;
      }

      const div = document.createElement("div");

      document.querySelector("body").append(div);

      ReactDom.render(
        <GlobalModal ref={modalRef} content={content} name={name} />,
        div,
      );

      return [name, modalRef];
    }),
  )(modalMounts);

  /* attach link handlers */

  if (R.isEmpty(modalRefs)) {
    return;
  }

  const modalIds = R.compose(
    R.join(", "),
    R.map((id) => `'${id}'`),
    R.keys,
  )(modalRefs);

  // Expose this function to the window so other components can use it
  window.openGlobalModal = (modalName) => {
    const modalRef = modalRefs[modalName];

    if (!modalRef) {
      console.error(
        `openGlobalModal can't find the modal, given '${modalName}'\n`,
        `Loaded modals ids: ${modalIds}`,
      );
      return;
    }

    closeOthers();
    modalRef.current.openModal();
  };

  // close all other global modals, this allows modal link inside a modal to
  // close itself and open the next modal
  const closeOthers = () => {
    R.compose(
      R.forEach((closeFn) => closeFn()),
      R.map(R.path(["current", "closeModal"])),
      R.values,
    )(modalRefs);
  };

  // setTimeout so the Modals above have a chance to render. We want to attach
  // the link handlers to the content of the modals too
  setTimeout(() => {
    Array.from(document.querySelectorAll(".js-global-modal-link")).forEach(
      (link) => {
        const modalRef = modalRefs[link.dataset.modal];

        if (!modalRef) {
          console.error(
            "This js-global-modal-link does not have a valid modal id!\n",
            `Loaded modals ids: ${modalIds}`,
            link,
          );
          return;
        }

        link.addEventListener("click", (e) => {
          // if the link has an href value, prevent that from firing.
          e.preventDefault();
          closeOthers();
          modalRef.current.openModal();
        });
      },
    );
  }, 0);
}
